// ProductList.jsx
import React, { useEffect, useState, useCallback } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { useCart } from './CartContext';
import './ProductList.css';

export default function ProductList() {
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [activeIdx, setActiveIdx] = useState(0);
  const [quantities, setQuantities] = useState({});
  const { cart, addToCart, removeFromCart } = useCart();
  const formatPrice = (price) => {
    return new Intl.NumberFormat('ru-RU', {
      maximumFractionDigits: 0,
    }).format(Number(price));
  };

  // helpers: безопасно получить обложку и массив картинок
  const getImages = useCallback((p) => p?.images ?? [], []);
  const getCover = useCallback((p) => {
    return (
      p?.cover_image_url ||
      p?.image || // fallback на старое поле
      'https://via.placeholder.com/300x150'
    );
  }, []);

  // переключение фото (после getImages/getCover!)
  const nextImage = useCallback(() => {
    if (!selectedProduct) return;
    const imgs = getImages(selectedProduct);
    if (imgs.length <= 1) return;
    setActiveIdx((i) => (i + 1) % imgs.length);
  }, [selectedProduct, getImages]);

  const prevImage = useCallback(() => {
    if (!selectedProduct) return;
    const imgs = getImages(selectedProduct);
    if (imgs.length <= 1) return;
    setActiveIdx((i) => (i - 1 + imgs.length) % imgs.length);
  }, [selectedProduct, getImages]);

  // загрузка товаров
  useEffect(() => {
    axios
      .get('https://metallpererabotka.ru/api/products/')
      .then((r) => setProducts(r.data))
      .catch((e) => console.error(e));
  }, []);

  // сброс индекса при смене товара
// сброс индекса при смене товара
  useEffect(() => {
    if (selectedProduct) setActiveIdx(0);
  }, [selectedProduct]);

  // 🚫 блокировка скролла при открытой модалке
// 🚫 Лочим страницу под модалкой без дёрганий и с сохранением позиции
useEffect(() => {
  const body = document.body;
  const docEl = document.documentElement;

  if (selectedProduct) {
    const scrollY = window.scrollY || window.pageYOffset;
    const scrollbarW = window.innerWidth - docEl.clientWidth;

    body.dataset.scrollY = String(scrollY);

    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';

    if (scrollbarW > 0) {
      body.style.paddingRight = `${scrollbarW}px`;
    }
  } else {
    const prevY = parseInt(body.dataset.scrollY || '0', 10) || 0;

    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    body.style.overflow = '';
    body.style.paddingRight = '';
    delete body.dataset.scrollY;

    window.scrollTo(0, prevY);
  }

  return () => {
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    body.style.overflow = '';
    body.style.paddingRight = '';
    delete body.dataset.scrollY;
  };
}, [selectedProduct]);



  // клавиатура: Esc/←/→
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') setSelectedProduct(null);
      if (!selectedProduct) return;
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'ArrowLeft') prevImage();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [selectedProduct, nextImage, prevImage]);

  return (
    <div className="product-list-wrapper">
      <h2 className="white-heading">Список товаров</h2>

      <div className="product-grid">
        {products.map((p) => {
          const cover = getCover(p);
          return (
            <div
              key={p.id}
              className="product-card"
              onClick={() => setSelectedProduct(p)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => (e.key === 'Enter' ? setSelectedProduct(p) : null)}
            >
              <img src={cover} alt={p.name} loading="lazy" />
              <div className="product-content">
                <h3>{p.name}</h3>
                <p><strong>{formatPrice(p.price)} ₽</strong></p>
              </div>
            </div>
          );
        })}
      </div>

      {/* --- модалка (портал) --- */}
      {selectedProduct &&
        ReactDOM.createPortal(
          <div className="modal-backdrop" onClick={() => setSelectedProduct(null)}>
            <div className="modal-window" onClick={(e) => e.stopPropagation()}>


      {/* Галерея */}
      <div className="image-wrapper">
                      <button className="modal-close" onClick={() => setSelectedProduct(null)} aria-label="Закрыть">
  ×
</button>
        {(() => {
          const imgs = getImages(selectedProduct);
          const activeUrl = imgs[activeIdx]?.url || getCover(selectedProduct);
          const hasMany = imgs.length > 1;

          return (
            <>
              <img src={activeUrl} alt={selectedProduct.name} />

              {/* NEW: открыть в новой вкладке */}
              <button
                type="button"
                className="open-image"
                title="Открыть фото в новой вкладке"
                aria-label="Открыть фото в новой вкладке"
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(activeUrl, '_blank', 'noopener,noreferrer');
                }}
              >
                ⤢
              </button>

              {hasMany && (
                <>
                  <button
                    className="nav-arrow left"
                    type="button"
                    aria-label="Предыдущее фото"
                    onClick={prevImage}
                  >
                    ‹
                  </button>
                  <button
                    className="nav-arrow right"
                    type="button"
                    aria-label="Следующее фото"
                    onClick={nextImage}
                  >
                    ›
                  </button>
                </>
              )}

              {hasMany && (
                <div className="thumbs">
                  {imgs.map((im, i) => (
                    <button
                      key={im.id ?? i}
                      className={`thumb ${i === activeIdx ? 'active' : ''}`}
                      onClick={() => setActiveIdx(i)}
                      aria-label={`Показать изображение ${i + 1}`}
                      type="button"
                    >
                      <img src={im.url} alt="" />
                    </button>
                  ))}
                </div>
              )}
            </>
          );
        })()}
          {(() => {
            const item = cart.find((i) => i.id === selectedProduct.id);
            if (!item) return null;
            const text = item.quantity >= selectedProduct.stock ? 'МАКС' : item.quantity;
            return <div className="quantity-overlay">{text}</div>;
          })()}

      </div>


              <h3>{selectedProduct.name}</h3>
              <p>{selectedProduct.description}</p>
              <div className="product-list-price"><strong>{formatPrice(selectedProduct.price)} ₽</strong></div>
              <div className="product-list-balance">Остаток: {selectedProduct.stock} тонн</div>

              <div className="cart-controls">
                <input
                  type="number"
                  min="1"
                  max={selectedProduct.stock}
                  value={quantities[selectedProduct.id] ?? ''}
                  placeholder="Введите число"
                  onChange={(e) => {
                    const v = parseInt(e.target.value, 10);
                    setQuantities((prev) => ({
                      ...prev,
                      [selectedProduct.id]: isNaN(v) ? undefined : Math.min(v, selectedProduct.stock),
                    }));
                  }}
                />
                <div className="cart-buttons">
                  <button
                    onClick={() => addToCart(selectedProduct, quantities[selectedProduct.id] || 1)}
                    type="button"
                  >
                    В корзину
                  </button>
                  <button
                    className="clear-btn"
                    onClick={() => {
                      removeFromCart(selectedProduct.id);
                      setQuantities((prev) => ({ ...prev, [selectedProduct.id]: undefined }));
                    }}
                    type="button"
                  >
                    Очистить
                  </button>
                </div>
              </div>

              <div className="marketplace-icons">
                {selectedProduct.link_ozon && (
                  <a href={selectedProduct.link_ozon} target="_blank" rel="noopener noreferrer">
                    <img src="/icons/512озон.png" alt="Ozon" className="marketplace-icon" />
                  </a>
                )}
                {selectedProduct.link_wb && (
                  <a href={selectedProduct.link_wb} target="_blank" rel="noopener noreferrer">
                    <img src="/icons/512вб.png" alt="WB" className="marketplace-icon" />
                  </a>
                )}
                {selectedProduct.link_yandex && (
                  <a href={selectedProduct.link_yandex} target="_blank" rel="noopener noreferrer">
                    <img src="/icons/512яндекс.png" alt="Yandex" className="marketplace-icon" />
                  </a>
                )}
              </div>
            </div>
          </div>,
          document.body
        )}
    </div>
  );
}
